'use client';
import { useState } from 'react';
import Image from 'next/image';
import { Typography } from '@bgzt/ui';

import globalStyles from '~/styles/utils.module.css';
import styles from './translateTrigger.module.css';
import translateIconUrl from '~/public/assets/icons/ic_translate.svg?url';
import clsx from 'clsx';
import { LogClick } from '~/components';
import { BUTTON_ID, EVENT_ACTION, EVENT_TYPE, PAGE_ID } from '~/apis/log/constant';

type Props = {
  onTranslate: (isTranslated: boolean) => void;
};

export const TranslateTrigger = ({ onTranslate }: Props) => {
  const [isTranslated, setIsTranslated] = useState(true);

  const handleClickTranslateButton = () => {
    const nextIsTranslated = !isTranslated;

    setIsTranslated(nextIsTranslated);

    onTranslate(nextIsTranslated);
  };

  return (
    <div className={styles.container}>
      <Image src={translateIconUrl} alt="" width={20} height={20} />
      &nbsp;
      <Typography variant="C2" color="gray-600">
        {isTranslated ? '자동 번역되었어요.' : '번역 전 원문이에요.'}
      </Typography>
      &nbsp;
      <LogClick
        params={{
          event_type: EVENT_TYPE.SELECT,
          event_action: EVENT_ACTION.SELECT_BUTTON,
          page_id: PAGE_ID.PRODUCT,
          button_id: BUTTON_ID.VIEW_ORIGINAL_TEXT,
        }}
      >
        <Typography
          variant="L11"
          color="gray-600"
          className={clsx(styles['linkText'], globalStyles['linkText'])}
          onClick={handleClickTranslateButton}
        >
          {isTranslated ? '원문보기' : '번역문보기'}
        </Typography>
      </LogClick>
    </div>
  );
};
